<template>
  <form-capsule :formTitle="$t('suppliers.form_supplier_create_title')">
    <template slot="formcontent">

      <div class="row">
        <form-write-group-label-input :isMandatory="true"
          :inputLabel="$t('suppliers.supplier_id')"
          :placeholderValue="$t('suppliers.supplier_id')"
          v-model="siren" :mandatoryErrorIndicator="sirenError"
          :regexpErrorIndicator="sirenRegexpError">
        </form-write-group-label-input>
        <form-write-group-label-input
          :disabled=true
          :inputLabel="$t('filter.supplier_id')"
          :placeholderValue="$t('filter.supplier_id')"
          v-model="sellerIdentifier"
          :mandatoryErrorIndicator="sellerIdentifierError" isMandatory>
        </form-write-group-label-input>
      </div>

      <div class="row">
        <form-write-group-label-input :isMandatory="true"
          :inputLabel="$t('common.social_reason')"
          :placeholderValue="$t('common.social_reason')"
          v-model="socialReason" :mandatoryErrorIndicator="socialReasonError">
        </form-write-group-label-input>
        <form-write-group-label-input
          :inputLabel="$t('suppliers.supplier_name')"
          :placeholderValue="$t('suppliers.supplier_name')"
          v-model="name">
        </form-write-group-label-input>
      </div>

      <div class="row">
        <form-write-group-label-input
          :inputLabel="$t('common.eml_adrs')"
          :placeholderValue="$t('common.eml_adrs')"
          v-model="emailAddress" :regexpErrorIndicator="emailAddressRegexpError">
        </form-write-group-label-input>
        <form-write-group-label-input
          :inputLabel="$t('common.street_name')"
          :placeholderValue="$t('common.street_name_example')"
          v-model="streetName">
        </form-write-group-label-input>
      </div>

      <div class="row">
        <form-write-group-label-input
          :inputLabel="$t('common.zp_code')"
          :placeholderValue="$t('common.zp_code')"
          v-model="zipCode">
        </form-write-group-label-input>
        <form-write-group-label-input
          :inputLabel="$t('common.cty')"
          :placeholderValue="$t('common.cty')"
          v-model="townName">
        </form-write-group-label-input>
      </div>

    </template>
    <template slot="footerbuttons">
      <div class="row justify-content-start">
        <div class="col-md-3 offset-md-8">
          <button round
            class="button-action firstButtonMarginTop col-md milkyBlockBlack"
            @click="updateSupplier">
            <i class="icon fa fa-save"></i>
            {{ $t('suppliers.form_supplier_edit_button') }}
          </button>
        </div>
      </div>
    </template>
  </form-capsule>
</template>
<script>
import formCapsule from '@/components/common/formCapsule.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {verifyMandatoryValues, verifyRegexpValues, checkErrorFlag} from '@/helpers/validator'
import {reloadPage} from '@/helpers/routing'

/** @author TLV - JPR 06/11/2020
* @brief Component for adding Suppliers
*/
export default {
  name: 'EditSupplierForm',
  components: {
    'form-capsule': formCapsule,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      sellerIdentifier: '',
      sellerIdentifierError: false,
      siren: '',
      sirenError: false,
      sirenRegexpError: false,
      socialReason: '',
      socialReasonError: false,
      name: '',
      emailAddress: '',
      emailAddressRegexpError: false,
      streetName: '',
      zipCode: '',
      townName: ''
    }
  },
  beforeMount () {
    let that = this
    var idSeller = that.$route.query.IdSeller
    that.updateToSeller(idSeller)
  },
  methods: {
    validateForm () {
      let flagsList = {}
      let mandatoryValues = ['siren', 'socialReason', 'sellerIdentifier']
      let regexpValues = {
        'siren': 'SIREN',
        'emailAddress': 'email'
      }
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      flagsList = verifyRegexpValues(regexpValues, flagsList, this)
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    },
    updateToSeller (idSeller) {
      let that = this
      that.$f7.showPreloader()
      that.$engine.services.suppliers.edit(idSeller)
        .then(response => {
          if (response.status === 200) {
            var sellers = response.data.Sellers[0]
            this.sellerIdentifier = sellers.SellerIdentifier
            this.siren = sellers.Siren
            this.socialReason = sellers.SocialReason
            this.name = sellers.Name
            this.emailAddress = sellers.Email
            this.streetName = sellers.StreetName
            this.townName = sellers.TownName
            this.zipCode = sellers.PostalCode
            that.$f7.hidePreloader()
          }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
    },
    updateSupplier () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      this.$f7.showPreloader(this.$i18n.t('loading.adding_supplier'))
      let that = this
      var idSeller = that.$route.query.IdSeller
      that.$engine.services.suppliers.updateSeller({
        IdSeller: idSeller,
        SellerIdentifier: this.sellerIdentifier,
        SocialReason: this.socialReason,
        Name: this.name,
        Siren: this.siren,
        Email: this.emailAddress,
        StreetName: this.streetName,
        PostalCode: this.zipCode,
        TownName: this.townName
      })
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: that.$i18n.t('success.supplier_edited'),
            text: '<i class="icon fa fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            reloadPage(that, {url: '/inbox/', force: true, ignoreCache: true})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    }
  }
}
</script>
